import * as classnames from 'classnames'
import * as React from 'react'

import { config } from '../../../common/config'
import ui from '../../../common/constants/ui'
import EnhancedLazyLoad from '../../components/enhancedLazyLoad'
import * as styles from './trendingSash.module.css'

interface IProps {
  large?: boolean
  lazy?: boolean
}

const srcUrl = `${config.assets.PUBLIC_PATH}/images/trending-sash.svg`

const TrendingSash = (props: IProps) => {
  const trendingSashClass = classnames(styles.root, {
    [styles.large]: props.large
  })

  const image = (
    <img className={trendingSashClass} alt="Trending" src={srcUrl} />
  )

  if (props.lazy) {
    return (
      <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
        {image}
      </EnhancedLazyLoad>
    )
  }

  return image
}

export default TrendingSash
